export default __webpack_public_path__ + "static/media/3stepweightloss@3x.5fdb87ed.jpg";